import React from 'react';
import { routes as r } from '../../../routes';
import { SchedulerShiftsCalendar } from '../SchedulerShiftsCalendar';
import { ColleaguesCalendar } from '../ColleaguesCalendar';
import { SentShiftChangeRequests } from '../SentShiftChangeRequests';
import { ReceivedShiftChangeRequests } from '../ReceivedShiftChangeRequests';

export const routes = () => ({
  schedulerShiftsCalendar: {
    route: r.schedulerShifts.route,
    render: () => <SchedulerShiftsCalendar />,
  },
  colleaguesCalendar: {
    route: r.schedulerShiftsColleagues.route,
    render: () => <ColleaguesCalendar />,
  },
  sentChangeRequests: {
    route: r.schedulerShiftsSentTransferRequests.route,
    render: () => <SentShiftChangeRequests />,
  },
  receivedChangeRequests: {
    route: r.schedulerShiftsReceivedTransferRequests.route,
    render: () => <ReceivedShiftChangeRequests />,
  },
});
